import Head from 'next/head'
import Image from "next/legacy/image";
import styles from "../styles/pages/Restaurant.module.scss"
import Link from 'next/link'
import Slider from "react-slick";
import Restaurantgallery from '../components/Restaurantgallery/Restaurantgallery'
import DiningPageForm from '../components/Contactusform/DiningPageForm';
import Accordion from '../components/Accordion/Accordion';
import { useState } from 'react';
import AboutGallery from '../components/AboutGallery/AboutGallery';
import FAQs from '../components/Faqs';
import WeddingPageForm from '../components/Contactusform/WeddingPageForm';

export default function Meeting() {

    const galleryImages = [
        {
            bgImage: "/images/events/meeting-gallery/meeting-img1.jpg",
            altTest: "Meeting image 1",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img2.jpg",
            altTest: "Meeting image 2",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img3.jpg",
            altTest: "Meeting image 3",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img4.jpg",
            altTest: "Meeting image 4",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img5.jpg",
            altTest: "Meeting image 5",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img6.jpg",
            altTest: "Meeting image 6",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img7.jpg",
            altTest: "Meeting image 7",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img8.jpg",
            altTest: "Meeting image 8",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img9.jpg",
            altTest: "Meeting image 9",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img10.jpg",
            altTest: "Meeting image 10",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img11.jpg",
            altTest: "Meeting image 11",
        },
        {
            bgImage: "/images/events/meeting-gallery/meeting-img12.jpg",
            altTest: "Meeting image 12",
        },
    ]

    const amenities = [
        {
            title: "Stage & Podium",
            description: "Sleek and modern podiums designed to enhance presentations and speeches.",
            hyperLink: "/",
            icon: "/icons/events/podium.svg"
        },
        {
            title: "Stationary Amenities",
            description: "Premium stationary including notepads and pens to boost productivity.",
            hyperLink: "/",
            icon: "/icons/events/stationary.svg"
        },
        {
            title: "Accommodation",
            description: "Luxurious rooms and suites provide a comfortable and memorable stay for guests.",
            hyperLink: "/",
            icon: "/icons/events/accomodation.svg"
        },
        {
            title: "Ample Parking",
            description: "Convenient and spacious parking facilities for all attendees.",
            hyperLink: "/",
            icon: "/icons/events/parking.svg"
        },
        {
            title: "Catering",
            description: "Delicious gourmet cuisine crafted to impress and delight every guest.",
            hyperLink: "/",
            icon: "/icons/events/catering.svg"
        },
        {
            title: "Entertainment",
            description: "Interactive games and engaging activities for all guests to enjoy.",
            hyperLink: "/",
            icon: "/icons/events/entertainment.svg"
        },

        {
            title: "Venue",
            description: "Stunning locations with breathtaking views, perfect for your special celebration.",
            hyperLink: "/",
            icon: "/icons/events/venue.svg"
        },
        {
            title: "Video & Photography",
            description: "Capture precious moments with professional videography and photography services.",
            hyperLink: "/",
            icon: "/icons/events/photography.svg"
        },

        // {
        //     title: "Adventure",
        //     description: "Exciting activities and experiences to thrill and entertain your guests.",
        //     hyperLink: "/",
        //     icon: "/icons/events/adventure.svg"
        // },
    ];

    const faqsData = [
        {
            id: 1,
            accordionQuestion: "Can the event venue in Shimla accommodate both small and large business events?",
            accordionAnswer: "Absolutely, our event venue in Shimla can host both small intimate gatherings and large-scale business events with ease."
        },
        {
            id: 2,
            accordionQuestion: "Is The Twin Towers Hotel considered the best event venue in Himachal Pradesh?",
            accordionAnswer: "Yes, The Twin Towers Hotel is renowned as the best event venue in Himachal Pradesh, known for its exceptional service and breathtaking views."
        },
        {
            id: 3,
            accordionQuestion: "Can The Hotel Twin Tower cater to adventure activities for event attendees?",
            accordionAnswer: "Yes, we offer outdoor adventure activities like Go-Karting, Bunjee Jumping, zip-lining, Frisbee, and much more to make your event memorable."
        },
        {
            id: 4,
            accordionQuestion: "What amenities are included in your event venue in Shimla for business events?",
            accordionAnswer: "Our event venue in Shimla includes high-speed internet, audio-visual equipment, and comfortable seating arrangements ideal for business events."
        },
        {
            id: 5,
            accordionQuestion: "Can your event venue in Shimla accommodate both corporate events and social gatherings?            ",
            accordionAnswer: "Certainly, our versatile event venue in Shimla is perfect for both corporate events and social gatherings, ensuring a successful and memorable occasion."
        }
    ];

    const scrollToSection = (redirectedSection) => {
        const section = document.getElementById(redirectedSection);
        if (section) {
            section.scrollIntoView({
                behavior: 'smooth',
            });
        }
    };

    const handleScrollClick = (section) => {
        return () => scrollToSection(section);
    };

    return (
        <>
            <Head>
                <title>Conference hall Meetings | Hotel Event Spaces | The Twin Towers Hotel in Kufri, Shimla</title>
                <meta name="description" content="Experience luxury and sophistication at The Twin Towers Hotel conference hall. Book now and make your next event unforgettable." />
                <link rel="icon" href="/favicon.svg" />
                <link rel="canonical" href="https://www.hoteltwintowers.com/conference-hall" />
                <meta name="keywords" content="Hotels In Shimla Best Hotels In Kufri conference hall meeting hall event space event venues corporate events birthday events"></meta>
            </Head>
            {/* <Slider {...settings} className="banner_slider">
                {bannerImages.map((item, index) => ( */}
            <section >
                <div
                    className={styles.wedding_meeting_banner}
                    style={{
                        backgroundImage: `url(/images/events/meeting-page-banner.png)`,
                    }}
                >
                     <div className={styles.banner_text}>
                        <div className="container">
                            <div className={styles.banner_btn}>
                                <Image src='/icons/down-arrow.svg' height={40} width={40} alt='Down Icon' onClick={handleScrollClick('homeSection')}></Image>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            {/* ))}
            </Slider> */}

            <section className={styles.best_venue_sec} id='homeSection'>
                <div className='container'>
                    <div className={`${styles.best_venue_sec_main} common_title`}>
                        <h1>Premier Event Venue in Shimla</h1>
                        <p>At The Twin Towers Hotel, we understand the importance of creating the right impression. Our venue, the best event venue in Shimla, is perfect for corporate events, business meetings, convocations, and felicitation ceremonies. Equipped with state-of-the-art technology, our spaces ensure seamless presentations and gatherings. Located in Kufri, Himachal Pradesh, our modern and elegant design provides the ideal backdrop for any event, making every occasion special and impactful.</p>
                    </div>
                </div>
            </section>

            <section className={`${styles.restaurant} common_padding`}>
                <div className='container'>
                    <div className={`${styles.restaurant_top} row`}>
                        <div className={`${styles.res_top_left} col-md-6 col-sm-12 common_title`}>
                            <div className={`${styles.center_div} col-md-10`}>
                                <h2>Exceptional Venue For Remarkable Events</h2>
                                <p>Our range of event halls can accommodate gatherings of all sizes and styles. From intimate business meetings to large-scale celebrations, our versatile spaces can be tailored to your specific needs. We offer a perfect blend of elegance and functionality, ensuring that your events are memorable and seamless. Trust us to provide the ideal setting for your special moments.</p>
                                <Link href="#book_your_event" className="common_btn m-0">Enquire Now</Link>
                            </div>

                        </div>
                        <div className={`${styles.res_top_right} col-md-6 col-sm-12`}>
                            <img src="/images/events/meeting-img2.png" alt='Restaurant Image' />
                        </div>
                    </div>
                    <div className={`${styles.restaurant_top_two} row`}>
                        <div className={`${styles.res_top_left_two} col-md-6 col-sm-12`}>
                            <img src="/images/events/meeting-img1.png" alt='Restaurant Image' />
                        </div>
                        <div className={`${styles.res_top_right_two} col-md-6 col-sm-12 common_title justify-content-end`}>
                            <div className={`${styles.center_div} col-md-10`}>
                                <h2>Expert Planning For Flawless Execution</h2>
                                <p>At The Twin Towers Hotel, we transform ideas into extraordinary events. Our team excels in planning and executing flawless celebrations, ensuring every detail is perfect. From corporate gatherings to personal milestones, our expertise and attention to detail make each event memorable. Elevate your event experience with our sophisticated spaces, impeccable service, and innovative approach. Let us bring your vision to life and create unforgettable moments for you and your guests.</p>
                                <Link href="#book_your_event" className="common_btn m-0">Enquire Now</Link>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className={`${styles.wedding_amenities}`}>
                <div className='container'>
                    <div className='common_title'>
                        <h2 className='text-center'>Services We Provide</h2>
                        <div className={`${styles.amenities_main} row`}>
                            {amenities.map((item, index) => (
                                <div key={index} className="col-sm-6 col-lg-3 col-md-6">
                                    <div className={styles.amenities}>
                                        <Image src={item.icon} width={50} height={50} className={styles} alt="Highlights icon" />
                                        <h3>{item.title}</h3>
                                        <p className='text-center'>{item.description}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
            <section className='common_padding'>
                <AboutGallery galleryImages={galleryImages} galleryHeading={'Successful Events'} />
            </section>

            <section style={{ backgroundColor: '#F5F5F5', paddingBottom: '0' }} id='book_your_event'>
                <div className='container'>
                    <WeddingPageForm formId={'conferenceBookingForm'} formClass={'event-booking-form'} />
                </div>
            </section>

            <div className='common_padding'>
                <div className="container">
                    <h2 className="hotel_page_hotel_haeding mb-2 text-center">FAQs</h2>
                    <FAQs faqsData={faqsData} />
                </div>
            </div>
        </>
    )
}